import React from 'react';
// ТЕСТ: импорт из новой структуры
import DarkModeToggle from '../ui/DarkModeToggle';
import LanguageSwitcher from '../ui/LanguageSwitcher';

const ControlsContainer: React.FC = () => {
  return (
    <div className="controls-container">
      <DarkModeToggle />
      <LanguageSwitcher />
    </div>
  );
};

export default ControlsContainer;